import { useMutation } from "react-query";
import { deleteOutboundFile, uploadLetterAttachment, uploadOutboundFile } from "@/services/outbound";
/** Mutation hook that uploads a file for an outbound document. */
export function useUploadOutboundFile(workspaceId, patientId) {
  return useMutation(function (file) {
    return uploadOutboundFile(workspaceId, patientId, file);
  });
}

/** Mutation hook that resolves a patient letter into an outbound attachment. */
export function useUploadLetterAttachment(workspaceId, patientId) {
  return useMutation(function (letterId) {
    return uploadLetterAttachment(workspaceId, patientId, letterId);
  });
}

/** Mutation hook that deletes a previously uploaded outbound file. */
export function useDeleteOutboundFile(workspaceId) {
  return useMutation(function (s3Key) {
    return deleteOutboundFile(workspaceId, s3Key);
  });
}